import type { SidebarSection, SidebarItem, SidebarChild } from '@/constants';

/**
 * Filtra secciones del sidebar por permisos del usuario.
 * Ítems sin `permission` son siempre visibles. Secciones que quedan sin ítems se ocultan.
 */
export function filterSectionsByPermissions(
  sections: SidebarSection[],
  userPermissions: string[]
): SidebarSection[] {
  return sections
    .map((section) => {
      const filteredItems = section.items
        .map((item: SidebarItem) => {
          if (item.children) {
            const filteredChildren = item.children.filter(
              (child: SidebarChild) =>
                !child.permission || userPermissions.includes(child.permission)
            );
            if (filteredChildren.length === 0) return null;
            return { ...item, children: filteredChildren };
          }
          if (item.permission && !userPermissions.includes(item.permission)) {
            return null;
          }
          return item;
        })
        .filter((item): item is SidebarItem => item !== null);

      if (filteredItems.length === 0) return null;
      return { ...section, items: filteredItems };
    })
    .filter((section): section is SidebarSection => section !== null);
}
